import { Window } from "@progress/kendo-react-dialogs"
import { useEffect } from "react";
import { useGetTenantQuery } from "../../../redux/api/BaseApi";
import { QuickNotePopupProps } from "../../../types/Props/QuickNotePopupProps";
import { trimChar } from "../../../utils/utils";

const AddQuickNote: React.FC<QuickNotePopupProps> = (props) => {
    const { data: tenant } = useGetTenantQuery();

    useEffect(() => {
        const listenForMessage = (ev) => {
            console.log('Lets GO!', ev)
            if (ev.data) {
                let dataObject = JSON.parse(ev.data);
                if (dataObject?.Message && dataObject?.Message === 'Quick_Note_Added') {
                    props.onSave(dataObject.ID);
                }
            }
        }

        window.addEventListener('message', listenForMessage);

        //remove the event listener when component unmounts
        return () => {
            window.removeEventListener('message', listenForMessage);
        };
    }, []);

    return (
        <Window className="p-0" modal={true}
            title='Add Quick Note'
            width={800}
            height={650}
            onClose={props.onClose}
        >
            <div className="relative flex flex-col grow">
                {tenant?.Tenant_Url && <iframe name="add-quick-note" height={550} className="grow" src={`${trimChar(tenant?.Tenant_Url, '/')}/Calls/AddQuickNote.aspx`} />}
            </div>
        </Window>
    )
}

export default AddQuickNote;